import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { ModalProps } from 'react-bootstrap/Modal';

export const Modal = styled(BootstrapModal)<ModalProps>`
  .modal-content {
    background-color: #eff3f6;
  }
`;
